import { render, staticRenderFns } from "./studentQuestionList.vue?vue&type=template&id=78f2a7f6&scoped=true"
import script from "./studentQuestionList.vue?vue&type=script&lang=js"
export * from "./studentQuestionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f2a7f6",
  null
  
)

export default component.exports